module.exports = __webpack_public_path__ + "components/profile/static/icon-edit-c9643df491a458dd102384c9fb359f2b.svg";